import { inject, Injectable } from '@angular/core';
import { CollaborationScreenService } from '@libs/collaboration';
import { ComponentStore } from '@ngrx/component-store';

const initialState = {
  filterUnreadOnly: false,
  filterDirectOnly: false,
};

interface MyCollaborationsSidebarState {
  filterDirectOnly: boolean;
  filterUnreadOnly: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppointmentDetailsCollaborationsFilterService extends ComponentStore<MyCollaborationsSidebarState> {
  private readonly collabScreenService = inject(CollaborationScreenService);

  constructor() {
    super(initialState);
  }

  public updateFilters({ directOnly, unreadOnly }: { directOnly: boolean; unreadOnly: boolean }): void {
    const { filterDirectOnly, filterUnreadOnly } = this.state();

    const directOnlyChanged = directOnly !== filterDirectOnly;
    const unreadOnlyChanged = unreadOnly !== filterUnreadOnly;

    if (!directOnlyChanged && !unreadOnlyChanged) {
      return;
    }

    this.patchState({ filterDirectOnly: directOnly, filterUnreadOnly: unreadOnly });
    this.collabScreenService.updateFilters({ filters: { directOnly, unreadOnly }, clearCollabs: false, fetchCollabs: true });
  }
}
